var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetDateTimePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.889 4.6H5.11C4.497 4.6 4 5.092 4 5.7v7.7c0 .607.497 1.1 1.111 1.1h7.778c.614 0 1.111-.492 1.111-1.1V5.7c0-.608-.498-1.1-1.111-1.1zM11.222 3.5v2.2M6.778 3.5v2.2",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 11.5V8.187a.1.1 0 0 0-.155-.083L7.8 9",
    stroke: "#535353",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetDateTimePicker);
export default __webpack_public_path__ + "static/media/widgetDateTimePicker.770ce2b4b7c7078b390d427f75abd79d.svg";
export { ForwardRef as ReactComponent };